import React from "react";
import { useNavigate } from "react-router-dom";
import { signOut } from "firebase/auth";
import { auth, db } from "../firebase";
export default function Header() {
  const navigate = useNavigate();
  const handleLogout = async () => {
    await signOut(auth);
    window.location.reload();
  };
  return (
    <div>
      <img class="center-logo" src="logo-copy.png" />
      <div className="navbar-buttons">
        <button className="navbar-btn" onClick={() => navigate("/dashboard")}>
          Go to Dashboard
        </button>
        <button className="navbar-btn" onClick={() => navigate("/schedule")}>
          Go to Schedule
        </button>
        <button
          className="navbar-btn"
          onClick={() => navigate("/other-banners")}
        >
          Other Banners
        </button>
        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
}
